import { type MergeWithCustomizer } from 'lodash';

/**
 * `mergeWith` customizer for combining short URL info with update params or server responses.
 *
 * The backend applies wholesale-replace semantics to the `presentationSettings.customColors` and
 * `presentationSettings.customFonts` sub-objects: when present in an update, each replaces the
 * stored object entirely, so clearing a color role or a font slot means sending the object without
 * that key. A default deep merge would resurrect cleared keys (and stray fields like a stale
 * `fontFamily` on a font-type switch) from the previous value, so an incoming sub-object must
 * replace, not merge. Every other key keeps lodash's default deep-merge behavior.
 *
 * `presentationContent` is wholesale-replaced too — the page body is one cohesive tree, so an
 * incoming value replaces the stored one entirely. Lodash's default merge combines arrays
 * index-by-index, which would resurrect deleted blocks from the previous value's longer `blocks`
 * array and cross-merge blocks of different types occupying the same index after a reorder.
 *
 * `presentationPages` is wholesale-replaced for the same reason: it is one flat overlay of a
 * collection share link's sub-pages, so an incoming value replaces the stored list entirely. Its
 * `subPages` array hits the identical index-by-index failure as `blocks` — deleting a sub-page
 * would leave the removed entry resurrected in the tail of the previous, longer array, and a
 * reorder that moves a `link` entry onto an index previously held by a `collection` entry would
 * cross-merge the two into a hybrid carrying both a `collectionId`/`content` and a `label`/`url`.
 */
export const replacePresentationSubObjectsMergeCustomizer: MergeWithCustomizer = (_objValue, srcValue, key) => {
  if (
    (key === 'customColors' || key === 'customFonts' || key === 'presentationContent' || key === 'presentationPages') &&
    srcValue !== undefined
  ) {
    return srcValue;
  }
};
